module.exports = __webpack_public_path__ + "796332d9bdb276f262dd35bf9007568f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-14@2x.png
// module id = 503
// module chunks = 0